import { DELETE, DELETE_WITH_PARAMS } from "../API"

export const deleteUserApi = (reasons, onSuccess, onError) => {
    const data = {
        reasons: reasons
    }
    DELETE_WITH_PARAMS("/api/v1/identity/users/delete", data, onSuccess, onError)
}